// @flow
import moment from 'moment';
import type { Moment } from 'moment';

const DEFAULT_START_DAY = 1;
export const CALENDAR_FORMAT = 'YYYY-MM-DD';
export const CALENDAR_KEYS_FORMAT = 'YYYY_M_D';

declare type DateObject = {
    year: string | number,
    month: string | number,
    day: string | number
};

export function now(): Moment {
    return moment();
}

export function convertToCalendarDate(date: string): Moment {
    return convertString(date, CALENDAR_FORMAT);
}

export function convertToCalendarKeysDate(date: string): Moment {
    return convertString(date, CALENDAR_KEYS_FORMAT);
}

export function convertToDate(
    dateData: string | DateObject,
    format: string
): Moment {
    if (typeof dateData === 'string') {
        return convertString(dateData, format);
    }
    return convert(dateData.year, dateData.month, dateData.day, format);
}

export function isSameDay(
    date: Date | string | Moment,
    dateToCompare: Date | string | Moment
): boolean {
    return convertDate(date).isSame(convertDate(dateToCompare));
}

export function isValidDateString(dateString: string): boolean {
    return !!dateString && moment(dateString).isValid();
}

export function convertDate(date: Date | string | Moment): Moment {
    let _date =
        isDateType(date) || isStringType(date)
            ? moment(date)
                  .local()
                  .startOf('day')
            : date.startOf('day');
    return _date;
}

function convert(
    year: string | number,
    month: string | number,
    day: string | number,
    format: string
): Moment {
    return moment(`${year}-${month}-${day || DEFAULT_START_DAY}`, format);
}

function convertString(date: string, format: string): Moment {
    return moment(date, format);
}

function isStringType(value: Date | string | Moment): boolean {
    return typeof value === 'string';
}

function isDateType(value: Date | string | Moment): boolean {
    return value instanceof Date;
}

// force variables are here to set the time to a particular time of day
// i.e. if we want the start of the day, the hour, minute, second
// respectively would be 0,0,1
// and if we want the end of the day, they would be 23, 59, 59
export function generateDateTimeAPIString(
    date: string,
    forceHours: ?number = null,
    forceMinutes: ?number = null,
    forceSeconds: ?number = null
) {
    let modifiedDate = moment(date, CALENDAR_FORMAT);
    if (forceHours !== null) {
        modifiedDate.hours(forceHours);
    }
    if (forceMinutes !== null) {
        modifiedDate.minutes(forceMinutes);
    }
    if (forceSeconds !== null) {
        modifiedDate.seconds(forceSeconds);
    }
    // convert to iso 8601
    return modifiedDate.format();
}
